import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'NumberButtons',
  props: {
    modelValue: {
      type: Number,
      default: 1,
      required: true,
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
    disableDecrease: {
      type: Boolean,
      default: false,
    },
    disableIncrease: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minValue: {
      required: false,
      type: Number,
    },
    maxValue: {
      required: false,
      type: Number,
    },
    lightTheme: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'input', 'increment', 'decrement'],
})
export default class NumberButtons extends Vue {
  modelValue!: number;
  allowNegative!: boolean;
  disableDecrease!: boolean;
  disableIncrease!: boolean;
  disabled!: boolean;
  minValue!: number;
  maxValue!: number;
  lightTheme!: boolean;

  setValue(newValue: number) {
    if (typeof this.minValue !== 'undefined' && newValue < this.minValue)
      return;
    if (typeof this.maxValue !== 'undefined' && newValue > this.maxValue)
      return;

    if (newValue < 0 && !this.allowNegative) return;

    this.$emit('update:modelValue', newValue);
    this.$emit('input', newValue);

    if (newValue > this.modelValue) this.$emit('increment');
    else this.$emit('decrement');
  }
}
